var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraySubtractCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0013 13.3332C10.2096 13.3332 12.8346 10.7082 12.8346 7.49984C12.8346 4.2915 10.2096 1.6665 7.0013 1.6665C3.79297 1.6665 1.16797 4.2915 1.16797 7.49984C1.16797 10.7082 3.79297 13.3332 7.0013 13.3332Z",
    stroke: "#777777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 7.5H9.33464",
    stroke: "#777777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraySubtractCircle);
export default __webpack_public_path__ + "static/media/gray-subtract-circle.0ca18a95f5d2689faa85708f75869a48.svg";
export { ForwardRef as ReactComponent };